import qs from 'qs'
import request from '@/utils/request'
import URL from '@/api/urlTranslator'
import {
  // eslint-disable-next-line no-unused-vars
  getEDITemplate
} from '@/api/sysManage/baseConfig/ediTemplate'

export function findEDIByJobNo(params) {
  return request({
    url: URL.edi.findEDIByJobNo,
    method: 'get',
    params
  })
}

export function findEDI(data) {
  return request({
    url: URL.edi.findEDI,
    method: 'post',
    data
  })
}

export function importEDITextFromTemplateUuid(data) {
  return request({
    url: URL.edi.importEDITextFromTemplateUuid,
    method: 'post',
    data
  })
}

export function getCanSendBookingJob(data) {
  return request({
    url: URL.edi.getCanSendBookingJob,
    method: 'post',
    data
  })
}

export function oneKeyBooking(data) {
  return request({
    url: URL.edi.oneKeyBooking,
    method: 'post',
    data
  })
}

export function noBooking(params) {
  return request({
    url: URL.edi.noBooking,
    method: 'post',
    params
  })
}

export function queryBookingStateStatistics(params) {
  return request({
    url: URL.edi.queryBookingStateStatistics,
    method: 'get',
    params
  })
}

export function getMatchedOrAllBookingTemplates(params) {
  return request({
    url: URL.edi.getMatchedOrAllBookingTemplates,
    method: 'get',
    params
  })
}

export function getLatestBookingRecord(params) {
  return request({
    url: URL.edi.getLatestBookingRecord,
    method: 'get',
    params
  })
}

export function getLastEdiRecord(params) {
  return request({
    url: URL.edi.getLastEdiRecord,
    method: 'get',
    params
  })
}

export function getBookingEDI(data) {
  return request({
    url: URL.edi.getBookingEDI,
    method: 'post',
    data
  })
}

export function getEDI(data) {
  return request({
    url: URL.edi.getEDI,
    method: 'post',
    data
  })
}

export function getEDIObject(data) {
  return request({
    url: URL.edi.getEDIObject,
    method: 'post',
    data
  })
}

export function getFtpEDI(data) {
  return request({
    url: URL.edi.getFtpEDI,
    method: 'post',
    data
  })
}

export function downLoadEDI(data) {
  return request({
    url: URL.edi.downLoadEDI,
    method: 'post',
    data
  })
}

export function getSinOTransApi(params) {
  return request({
    url: URL.edi.getSinOTransApi,
    method: 'get',
    params
  })
}

/**
 * 获取提单edi
 * @param params
 */
export function getLadingBillEDI(params) {
  return request({
    url: URL.edi.getLadingBillEDI,
    method: 'get',
    params
  })
}

/**
 * 获取VGM edi
 * @param params
 */
export function getVGMEDI(params) {
  return request({
    url: URL.edi.getVGMEDI,
    method: 'get',
    params
  })
}

/**
 * 获取海运出口代理 edi
 * @param params
 */
export function getOverseaAgentEDI(params) {
  return request({
    url: URL.edi.getOverseaAgentEDI,
    method: 'get',
    params
  })
}

/**
 * 获取海运出口代理 edi
 * @param params
 */
export function getCargoWiseEDI(params) {
  return request({
    url: URL.edi.getCargoWiseEDI,
    method: 'get',
    params
  })
}

/**
 * 获取安装箱单 edi
 * @param params
 */
export function getInstallEDI(params) {
  return request({
    url: URL.edi.getInstallEDI,
    method: 'get',
    params
  })
}

/**
 * 获取预配舱单 edi
 * @param params
 */
export function getPreshippingEDI(data) {
  return request({
    url: URL.edi.getPreshippingEDI,
    method: 'post',
    data
    // paramsSerializer: params => qs.stringify({ ...params }, { arrayFormat: 'repeat' })
  })
}

/**
 * 获取舱单 edi
 * @param params
 */
export function getShippingEDI(params) {
  return request({
    url: URL.edi.getShippingEDI,
    method: 'get',
    params,
    paramsSerializer: params => qs.stringify({ ...params }, { arrayFormat: 'repeat' })
  })
}

/**
 * 获取反恐舱单 edi
 * @param params
 */
export function getJP24EDI(params) {
  return request({
    url: URL.edi.getJP24EDI,
    method: 'get',
    params,
    paramsSerializer: params => qs.stringify({ ...params }, { arrayFormat: 'repeat' })
  })
}

/**
 * 反恐舱单 edi api
 * @param params
 */
export function getEFreight(data) {
  return request({
    url: URL.edi.getEFreight,
    method: 'post',
    data
  })
}

export function getAfrEFreight(data) {
  return request({
    url: URL.edi.getAfrEFreight,
    method: 'post',
    data
  })
}

export function sendAfrEFreightXml(data) {
  return request({
    url: URL.edi.sendAfrEFreightXml,
    method: 'post',
    data
  })
}

/**
 * 查询多个job提单信息
 * @param params
 */
export function queryJobsCargoDoc(params) {
  return request({
    url: URL.edi.queryJobsCargoDoc,
    method: 'get',
    params,
    paramsSerializer: params => qs.stringify({ ...params }, { arrayFormat: 'repeat' })
  })
}

/**
 * 获取清洁舱单 edi
 * @param params
 */
export function getIFCSUMEDI(data) {
  return request({
    url: URL.edi.getIFCSUMEDI,
    method: 'post',
    data
    // paramsSerializer: params => qs.stringify({ ...params }, { arrayFormat: 'repeat' })
  })
}

/**
 * 提箱
 * @param params
 */
export function issuedSuitcase(data) {
  return request({
    url: URL.edi.issuedSuitcase,
    method: 'post',
    data
  })
}

/**
 * 查看历史
 * @param params
 */
export function getEdiHistory(params) {
  return request({
    url: URL.edi.getEdiHistory,
    method: 'get',
    params
  })
}

/**
 * ubi与99路电子箱单接口
 * @param params
 */
export function sendEDIEContainer(data) {
  return request({
    url: URL.edi.sendEDIEContainer,
    method: 'post',
    data
  })
}

/**
 * 电子箱单发送历史记录
 * @param params
 */
export function queryEContainerHistories(params) {
  return request({
    url: URL.edi.queryEContainerHistories,
    method: 'get',
    params
  })
}

/**
 * EDI模块-SCFI-申报数据
 * @param params
 */
export function commitDeclaration(data, filingType) {
  return request({
    url: `${URL.edi.commitDeclaration}/${filingType}`,
    method: 'post',
    data
  })
}

/**
 * EDI模块-SCFI空提交
 * @param params
 */
export function commitNone(filingType) {
  return request({
    url: `${URL.edi.commitNone}/${filingType}`,
    method: 'post'
  })
}

/**
 * EDI模块-SCFI申报历史
 * @param params
 */
export function queryScfiHistoryPageable(params) {
  return request({
    url: `${URL.edi.queryScfiHistoryPageable}`,
    method: 'get',
    params
  })
}

/**
 * EDI模块-反恐舱单-地址格式化-单号抄录-搜索没有并单过的Job
 * @param params
 */
export function findNoJoinSeaExportJob(params) {
  return request({
    url: `${URL.edi.findNoJoinSeaExportJob}`,
    method: 'get',
    params
  })
}

/**
 * EDI模块-反恐舱单-地址格式化-单号抄录-搜索货运单据
 * @param params
 */
export function searchCargoDoc(params) {
  return request({
    url: `${URL.edi.searchCargoDoc}`,
    method: 'get',
    params
  })
}

// 根据AMS_NO返回AMS日志
export function queryAMSLogByAmsNo(params) {
  return request({
    url: URL.edi.queryAMSLogByAmsNo,
    method: 'get',
    params
  })
}

export function getPreshippingManifestInfoEDI(data) {
  return request({
    url: URL.edi.getPreshippingManifestInfoEDI,
    method: 'post',
    data
  })
}
export function getIFCSUMManifestInfoEDI(data) {
  return request({
    url: URL.edi.getIFCSUMManifestInfoEDI,
    method: 'post',
    data
  })
}
export function getVGM2ManifestInfoEDI(params) {
  return request({
    url: URL.edi.getVGM2ManifestInfoEDI,
    method: 'get',
    params
  })
}
export function getVesselEDI(params) {
  return request({
    url: URL.edi.getVesselEDI,
    method: 'get',
    params
  })
}
// 宁波电子口岸api
export function getNingBoEportAPI(data) {
  return request({
    url: URL.edi.getNingBoEportAPI,
    method: 'post',
    data
  })
}
// 民生API
export function getMingShenBookingAPI(data) {
  return request({
    url: URL.edi.getMingShenBookingAPI,
    method: 'post',
    data
  })
}
// 民生API-EDI
export function getMingShenBookingEdiAPI(data) {
  return request({
    url: URL.edi.getMingShenBookingEdiAPI,
    method: 'post',
    data
  })
}
// 获取指定报文类型的下一个版本号
export function getNextEDIVersion(params) {
  return request({
    url: URL.edi.getNextEDIVersion,
    method: 'get',
    params
  })
}
// 获取指定报文类型的发送日志
export function queryEDISendLogMessage(data) {
  return request({
    url: URL.edi.queryEDISendLogMessage,
    method: 'post',
    data
  })
}

// 上传EDI文件到云存储
export function uploadEdiFile(data) {
  return request({
    url: URL.edi.uploadEdiFile,
    method: 'post',
    data
  })
}

// 校验是否发送过Gofreight
export function checkIsSended(params) {
  return request({
    url: URL.edi.checkIsSended,
    method: 'get',
    params
  })
}

// 发送 go freight
export function sendGoFreight(data) {
  return request({
    url: URL.edi.sendGoFreight,
    method: 'post',
    data: data
  })
}

// 查询发送日志
export function querySendLog(params) {
  return request({
    url: URL.edi.querySendLog,
    method: 'get',
    params
  })
}

// 荆艺系统预报推送
export function sendKinNit(data) {
  return request({
    url: URL.edi.sendKinNit,
    method: 'post',
    data
  })
}

// E2OPEN 发送
export function sendE2open(data) {
  return request({
    url: URL.edi.sendE2open,
    method: 'post',
    data: data
  })
}

// 吉联新api
export function getJiLianStarAPI(data) {
  return request({
    url: URL.edi.getJiLianStarAPI,
    method: 'post',
    data
  })
}

export function compareManifestInfoJc(params) {
  return request({
    url: URL.seaExport.compareManifestInfoJc,
    method: 'post',
    params
  })
}

// 壹沓-标准订舱接口
export function ydBookingEDI(data) {
  return request({
    url: URL.edi.ydBookingEDI,
    method: 'post',
    data
  })
}

// 获取Job、及壹沓回执结果
export function queryYDBookingResultsAndJob(data) {
  return request({
    url: URL.edi.queryYDBookingResultsAndJob,
    method: 'post',
    data
  })
}

// 确认覆盖/都不覆盖壹沓回执
export function updateByYdBookingResults(data) {
  return request({
    url: URL.edi.updateByYdBookingResults,
    method: 'post',
    data
  })
}

// 是否可以创建订阅回执
export function canSubscribeReceipt(data) {
  return request({
    url: URL.edi.canSubscribeReceipt,
    method: 'post',
    data
  })
}

// 创建订阅回执
export function subscribeReceiptExec(data) {
  return request({
    url: URL.edi.subscribeReceiptExec,
    method: 'post',
    data
  })
}
